import { createAction, props } from '@ngrx/store';
import { Suggestion } from '@fantaz/shared/data-access/models';

export const init = createAction('[Suggestions Page] Init');

export const loadSuggestionsSuccess = createAction(
  '[Suggestions/API] Load Suggestions Success',
  props<{ suggestions: Suggestion[] }>(),
);

export const loadSuggestionsFailure = createAction(
  '[Suggestions/API] Load Suggestions Failure',
  props<{ error: any }>(),
);
